export default "__VITE_ASSET__Cw$wn0JR__"